import { type MaybeRefOrGetter, toValue } from 'vue'
import { useMutationWithInvalidation } from '@/shared/composables/useMutationWithInvalidation'
import { approveTariffs } from './api/approveTariffs'
import type { TOUProfile } from './types';
import { saveTouProfile } from './api/saveTouProfile';
import { tariffQueryKeys } from './query-keys';

export const useApproveTariffs = (
  userId: MaybeRefOrGetter<string | undefined>
) => useMutationWithInvalidation(
    {
      mutationFn: async (groupKeys: string[]) => approveTariffs(groupKeys, toValue(userId)),
      invalidateOn: 'all'
    },
    [
      tariffQueryKeys.tariffs.all()
    ]
)

export const useSaveTouProfile = () =>
  useMutationWithInvalidation(
    (profile: MaybeRefOrGetter<TOUProfile[]>) => saveTouProfile(toValue(profile)),
    [
      tariffQueryKeys.timeOfUseConfigs.all()
    ]
  );

